import React, { useState } from 'react';
import { formatCurrency } from '../utils/currencyFormatter';
import { PlusIcon, SearchIcon, FilterIcon } from 'lucide-react';
export function InvoiceList({
  invoices,
  onViewInvoice,
  setCurrentView,
  locale = 'en-US'
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterMatching, setFilterMatching] = useState('all');
  const filteredInvoices = invoices.filter(invoice => {
    // Search term filter
    const matchesSearch = invoice.vendor.toLowerCase().includes(searchTerm.toLowerCase()) || invoice.invoiceNumber.toLowerCase().includes(searchTerm.toLowerCase()) || invoice.poReference && invoice.poReference.toLowerCase().includes(searchTerm.toLowerCase());
    // Status filter
    const matchesStatus = filterStatus === 'all' || invoice.status.toLowerCase() === filterStatus.toLowerCase();
    // Matching filter
    const matchesMatching = filterMatching === 'all' || invoice.matchingStatus === filterMatching;
    return matchesSearch && matchesStatus && matchesMatching;
  });
  return <div data-id="element-863">
      <div className="mb-8 flex justify-between items-center" data-id="element-864">
        <div data-id="element-865">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-866">Invoices</h2>
          <p className="mt-1 text-sm text-gray-500" data-id="element-867">
            View and manage all invoices
          </p>
        </div>
        <button onClick={() => setCurrentView('invoice-entry')} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-868">
          <PlusIcon className="h-4 w-4 mr-1" data-id="element-869" />
          New Invoice
        </button>
      </div>
      {/* Search and Filters */}
      <div className="mb-6 bg-white p-4 shadow rounded-lg" data-id="element-870">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-871">
          <div className="md:col-span-2" data-id="element-872">
            <label htmlFor="search" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-873">
              Search
            </label>
            <div className="relative rounded-md shadow-sm" data-id="element-874">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-875">
                <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-876" />
              </div>
              <input type="text" name="search" id="search" className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md p-2 border" placeholder="Search by supplier, invoice number or PO reference" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-877" />
            </div>
          </div>
          <div data-id="element-878">
            <label htmlFor="status-filter" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-879">
              Status
            </label>
            <select id="status-filter" name="status-filter" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md" value={filterStatus} onChange={e => setFilterStatus(e.target.value)} data-id="element-880">
              <option value="all" data-id="element-881">All Statuses</option>
              <option value="draft" data-id="element-882">Draft</option>
              <option value="pending" data-id="element-883">Pending</option>
              <option value="approved" data-id="element-884">Approved</option>
              <option value="in review" data-id="element-885">In Review</option>
            </select>
          </div>
          <div data-id="element-886">
            <label htmlFor="matching-filter" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-887">
              Matching Status
            </label>
            <select id="matching-filter" name="matching-filter" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md" value={filterMatching} onChange={e => setFilterMatching(e.target.value)} data-id="element-888">
              <option value="all" data-id="element-889">All</option>
              <option value="matched" data-id="element-890">Fully Matched</option>
              <option value="partial" data-id="element-891">Partially Matched</option>
              <option value="none" data-id="element-892">Not Matched</option>
            </select>
          </div>
        </div>
      </div>
      {/* Invoices Table */}
      <div className="bg-white shadow overflow-hidden sm:rounded-md" data-id="element-893">
        <div className="overflow-x-auto" data-id="element-894">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-895">
            <thead className="bg-gray-50" data-id="element-896">
              <tr data-id="element-897">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-898">
                  Invoice
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-899">
                  Supplier
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-900">
                  Date
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-901">
                  Amount
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-902">
                  PO Reference
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-903">
                  Status
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-904">
                  Matching
                </th>
                <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-905">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-906">
              {filteredInvoices.length > 0 ? filteredInvoices.map(invoice => <tr key={invoice.id} className="hover:bg-gray-50" data-id="element-907">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-908">
                      {invoice.invoiceNumber}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-909">
                      {invoice.vendor}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-910">
                      {invoice.invoiceDate}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-911">
                      {formatCurrency(invoice.amount, invoice.currency, locale)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-912">
                      {invoice.poReference || '-'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-913">
                      <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                        ${invoice.status === 'Approved' ? 'bg-green-100 text-green-800' : invoice.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' : invoice.status === 'Draft' ? 'bg-gray-100 text-gray-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-914">
                        {invoice.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-915">
                      {invoice.matchingStatus === 'matched' ? <span className="text-green-600" data-id="element-916">✅ Matched</span> : invoice.matchingStatus === 'partial' ? <span className="text-yellow-600" data-id="element-917">⚠️ Partial</span> : <span className="text-red-600" data-id="element-918">❌ No match</span>}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-919">
                      <button onClick={() => {
                  onViewInvoice(invoice);
                  // You could navigate to a detail view here
                }} className="text-indigo-600 hover:text-indigo-900 mr-3" data-id="element-920">
                        View
                      </button>
                      {invoice.status === 'Pending' && <button onClick={() => setCurrentView('matching')} className="text-green-600 hover:text-green-900" data-id="element-921">
                          Match
                        </button>}
                    </td>
                  </tr>) : <tr data-id="element-922">
                  <td colSpan={8} className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-923">
                    No invoices found matching your criteria
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}